import {createReducer} from "@reduxjs/toolkit";
import {SessionsActions} from "./sessions.action";

const initialState = {
  loading: false,
  error: false,
  list: []
};

export const SessionsReducer = {
  sessions: createReducer(initialState, (builder => {
    builder
      .addCase(SessionsActions.fetchList.pending, (state, _) => {
        console.log('[SessionsActions.fetchList.pending]: ')
        return {
          ...state,
          loading: true,
          error: false
        }
      })
      .addCase(SessionsActions.fetchList.rejected, (state, _) => {
        console.log('[SessionsActions.fetchList.rejected]: ')
        return {
          ...state,
          loading: false,
          error: true
        }
      })
      .addCase(SessionsActions.fetchList.fulfilled, (state, {payload}) => {
        console.log('[SessionsActions.fetchList.fulfilled]: ', payload)

        return {
          ...state,
          list: payload,
          loading: false,
          error: false,
        }
      })
  }))
}
